import styled, { css } from 'styled-components';
import ChevronDown from '@panel/commons/assets/icons/ChevronDown.svg';
import ChevronUp from '@panel/commons/assets/icons/ChevronUp.svg';
import { select } from '@panel/commons/core/themev2';

const Container = styled.div`
  height: fit-content;
  width: auto;
  display: block;
  margin-top: 56px;
  margin-bottom: 56px;
  margin-left: 11.33%;
  margin-right: 11.33%;
  @media (min-width: 1369px) {
    margin-left: 22.5%;
    margin-right: 22.5%;
    width: auto;
  }
  @media (max-width: 820px) {
    width: 100%;
    margin-top: 57px;
    margin-bottom: 57px;
    margin-left: 0;
    margin-right: 0;
  }
`;

const Title = styled.div`
  width: 100%;
  font-weight: 700;
  font-size: ${({ device }) => (device === 'mobile' ? '24px' : '32px')};
  line-height: ${({ device }) => (device === 'mobile' ? '130%' : '51px')};
  text-align: center;
  margin-bottom: 64px;
  @media (max-width: 820px) {
    width: 100%;
    margin-bottom: 46px;
  }
`;

const DropDownAcordion = styled.div`
  height: fit-content;
  width: 80%;
  @media (min-width: 1366px) {
    margin-left: 0;
    margin-right: 0;
    width: auto;
  }
  @media (min-width: 1024px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        width: auto;
      `}
  }
  @media (max-width: 820px) {
    margin-left: 18px;
    margin-right: 18px;
    width: auto;
  }
`;

const DropDownOption = styled.div`
  display: block;
`;
const HeaderContainter = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  cursor: pointer;
`;

const Ask = styled.div`
  font-family: Hind;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  color: ${select('black')};
  width: fit-content;
  white-space: break-spaces;
  @media (max-width: 1024px) {
    height: fit-content;
    font-size: 18px;
    line-height: 23.4px;
  }
`;

const Answer = styled.div`
  display: inline-block;
  font-family: Hind;
  font-size: 16px;
  font-weight: 400;
  line-height: 25.62px;
  color: ${select('black')};
  white-space: break-spaces;
`;

const Chevron = styled.button`
  background-image: ${({ isOpen }) => `url(${isOpen ? ChevronUp : ChevronDown})`};
  width: 24px;
  height: 24px;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 8px;
  margin-bottom: 10px;
  align-self: flex-end;
  cursor: pointer;
`;

const LineBottom = styled.hr`
  background-color: ${select('midLightGray')};
  height: 1px;
  width: 100%;
  margin-top: ${({ isOpen }) => `${isOpen ? '20px' : 0}`};
  margin-bottom: 20px;
`;

export { Container, Title, DropDownAcordion, DropDownOption, HeaderContainter, Ask, Chevron, Answer, LineBottom };
